import { client } from '../../../api';

/**
 * Recupera la lista paginata dei profili.
 * @param {number} page
 * @param {number} perPage
 * @returns {Promise}
 */
export function getProfiles(page = 1, perPage = 10) {
    return client.post('/filter/profiles', {
        page,
        per_page: perPage,
    });
}

/**
 * Crea un nuovo profilo.
 * @param {object} data - { name: string, rules: Rule[], enabled: boolean }
 * @returns {Promise}
 */
export function createProfile(data) {
    console.log('[createProfile] payload:', data);
    return client.post('/profiles', data);
}

/**
 * Aggiorna un profilo esistente (aggiornamento parziale).
 * @param {string} id - UUID del profilo
 * @param {object} data - Campi da aggiornare
 * @returns {Promise}
 */
export function updateProfile(id, data) {
    return client.patch(`/profiles/${id}`, data);
}

/**
 * Elimina un profilo.
 * @param {string} id - UUID del profilo
 * @returns {Promise}
 */
export function deleteProfile(id) {
    return client.delete(`/profiles/${id}`);
}
